import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../shared/auth/auth.service';

@Component({
    selector: 'app-login-redirect',
    templateUrl: './login-redirect.component.html',
    styles: []
})
export class LoginRedirectComponent implements OnInit {

    constructor(private authService: AuthService) { }

    ngOnInit() {
        // console.log(1111);
        // localStorage.setItem('configMenu', '');
        this.authService.completeAuthentication();
    }
}
